import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { cmsApiConfig } from '../../../cmsConfig';
import { DropdownAlternative } from '../../../types/Application/application';
import {
  AdjustmentAidFullTexts,
  AdjustmentAidStartTexts,
  BankruptcyContactFlowSubmitRequest,
  ExistingAutomatedBankruptcyIncidentLookupResult,
  SumbitApplicationDTO,
} from '../../../types/Application/adjustmentAid';

export const adjustmentAidApi = createApi({
  reducerPath: 'adjustmentAidApi',
  baseQuery: fetchBaseQuery({ baseUrl: cmsApiConfig.url }),
  endpoints: (builder) => ({
    getStartTexts: builder.query<AdjustmentAidStartTexts, void>({
      query: () => `/adjustmentAidApplication/getStartTexts`,
    }),
    getFullTexts: builder.query<AdjustmentAidFullTexts, void>({
      query: () => `/adjustmentAidApplication/getFullTexts`,
    }),
    getUnions: builder.query<DropdownAlternative[], void>({
      query: () => `/adjustmentAidApplication/getUnions`,
      transformResponse: (res: [{ id: string; name: string }]) => {
        const transformedUnions = res.map((union) => {
          const transformedUnion: DropdownAlternative = {
            id: union.id,
            value: union.name,
          };
          return transformedUnion;
        });

        return transformedUnions;
      },
    }),
    submitApplication: builder.mutation<void, SumbitApplicationDTO>({
      query: (formData) => ({
        url: `/adjustmentAidApplication/saveForm/`,
        method: 'POST',
        body: formData,
        cache: 'no-cache',
      }),
    }),
    getExistingAutomatedBankruptcyIncident: builder.query<
      ExistingAutomatedBankruptcyIncidentLookupResult,
      string
    >({
      query: (organisationNumber) =>
        `/adjustmentAidApplication/getExistingAutomatedBankruptcyIncident?organisationNumber=${organisationNumber}`,
    }),
    submitExistingAutomatedBankruptcyContact: builder.mutation<
      boolean,
      BankruptcyContactFlowSubmitRequest
    >({
      query: (request) => ({
        url: `/adjustmentAidApplication/submitExistingAutomatedBankruptcyContact`,
        method: 'POST',
        body: request,
        cache: 'no-cache',
      }),
    }),
  }),
});

export const {
  useLazyGetUnionsQuery,
  useLazyGetStartTextsQuery,
  useLazyGetFullTextsQuery,
  useSubmitApplicationMutation,
  useLazyGetExistingAutomatedBankruptcyIncidentQuery,
  useSubmitExistingAutomatedBankruptcyContactMutation,
} = adjustmentAidApi;
